import { FC, PropsWithChildren } from 'react';
import styles from './Title.css';

interface ITitleProps {
  isMain?: boolean;
}

export const Title: FC<PropsWithChildren<ITitleProps>> = ({ children, isMain }) => {
  const Tag = isMain ? 'h1' : 'h2';

  return <Tag className={styles['title']}>{children}</Tag>;
};
